import React, {useEffect, useState} from "react";
import {connect, useSelector} from "react-redux";
import {getClassNamesForThButton, useSortableData, alphabetizeByAttributeReverse} from "../common/Helpers";
import {WorkflowListItem} from "./WorkflowListItem";
import {deleteContract, getContracts, clearContracts, getContractsOfProject} from "../../actions/contract";

export function WorkflowList(props) {

    const contracts = useSelector((state) => state.contract.contracts);
    const invitations = useSelector((state) => state.contract.invitations);
    const noContractsExist = useSelector((state) => state.contract.noContractsExist);
    const projectDrop = useSelector((state) => state.projects.projectDrop);

    const relevantContracts = projectDrop.project_id ? contracts.filter(contract => contract.project_id === projectDrop.project_id) : contracts;
    const relevantInvites = projectDrop.project_id ? invitations.filter(invite => invite.project_id === projectDrop.project_id) : invitations;
    const relListDefaultSort = alphabetizeByAttributeReverse([...relevantContracts, ...relevantInvites], "date_created");

    const {items, requestSort, sortConfig} = useSortableData(relListDefaultSort);

    const sortedInvites = items.filter(item => item.role_id)
    const sortedContracts = items.filter(item => !item.role_id)

    const [companyClicks, setCompanyClicks] = useState(0);
    const [render, setRender] = useState(noContractsExist || contracts.length > 0);
    const [companyTitle, setCompanyTitle] = useState("Purchaser / Vendor")

    // Start rendering the component only once the list data is returned
    useEffect(() => {
        if (!render) {
            (noContractsExist || contracts.length > 0) && setRender(true);
        }
    }, [noContractsExist, contracts]);


    const handleSelectWfItem = (e) => {
        const id = e.currentTarget.getAttribute("to-id");
        const mode = e.currentTarget.getAttribute("to-mode");
        props.history.push(`/mng/workflow/${mode}/${id}`);
    }

    const sortByCompany = companyTitle === "Purchaser / Vendor" ? "Purchaser" : "Vendor"

    const toggleCompanySort = () => {
        if (companyClicks < 2 || companyClicks === 4) {
            requestSort("company_purchaser_name")
        } else {
            requestSort("company_vendor_name")
        }
        companyClicks === 4 
        ? setCompanyClicks(1)
        : setCompanyClicks(companyClicks + 1);
    }

    const toggleSortOther = (key) => {
        setCompanyClicks(0);
        requestSort(key);
    }

    useEffect(() => {
        // unless toggling away, set company heading
        if (companyClicks > 0) {
            if (companyClicks < 3) {
                setCompanyTitle("Purchaser / Vendor")
            } else {
                setCompanyTitle("Vendor / Purchaser")
            }
        }
    }, [companyClicks])

    
    const noResults = 
        <div className="page-card narrow light-black g5-text" >
            You have no contracts yet
            {projectDrop.project_id && <>&nbsp;for project <span className="heavy">{projectDrop.project_name}</span></>}
            .
        </div>


    const companyClass = (sortConfig?.key === "company_purchaser_name" || sortConfig?.key === "company_vendor_name") ? sortConfig?.direction : "";

    

    const tableHead = 
        <thead>
            <tr>
                <th className="content2 heavy-grey flexi first" style={{width: "25%"}} >
                    <button type="button" onClick={() => toggleSortOther("contract_name")} className={getClassNamesForThButton("contract_name", sortConfig)}>
                        Contract Name
                    </button>
                </th>
                <th className="content2 heavy-grey flexi " style={{width: "22%"}} >
                    <button type="button" onClick={() => toggleSortOther("project_name")} className={getClassNamesForThButton("project_name", sortConfig)}>
                        Parent Project
                    </button>
                </th>

                <th className="content2 heavy-grey flexi" style={{width: "22%"}} >
                    <button type="button" onClick={() => toggleCompanySort()} className={companyClass} >
                        {companyTitle}
                    </button>
                </th>
                <th className="content2 heavy-grey flexi" style={{width: "22%"}} >
                    <button type="button" onClick={() => toggleSortOther("date_created")} className={getClassNamesForThButton("date_created", sortConfig)}>
                        My Role
                    </button>
                </th>
                <th className="content2 heavy-grey rigid last-cell" colSpan="1">
                    <button type="button" onClick={() => toggleSortOther("contract_status")} className={getClassNamesForThButton("contract_status", sortConfig)}>
                        Status
                    </button>
                </th>
            </tr>
        </thead>

    const contractTable = 
        <table className="card-table">
            {tableHead}
            <tbody id="section1">
                {sortedInvites.length > 0 && <tr><th className="content3 p4-text p8b action-header" colSpan="8" >CONTRACT INVITATIONS</th></tr>}
                {sortedInvites.map((contract) => { 
                    return (
                        <WorkflowListItem contract={contract} key={contract.role_id} handleSelectWfItem={handleSelectWfItem} sortByCompany={sortByCompany} />
                    )
                })}
            </tbody>
            <tbody id="section2">
                {sortedContracts.length > 0 && <tr><th className="content3 g3-text g8 action-header" colSpan="8" >MY CONTRACTS</th></tr>}
                {sortedContracts.map((contract) => { 
                    return (
                        <WorkflowListItem contract={contract} key={contract.contract_id} handleSelectWfItem={handleSelectWfItem} sortByCompany={sortByCompany} />
                    )
                })}
            </tbody>
        </table>




    return (
        <>{render &&
            <>
            <div className="table-wrapper ">
                {items.length > 0 ? contractTable : noResults}
            </div>
            </>
        }</>
    )
}

const mapStateToProps = () => ({})

export default connect(mapStateToProps, {deleteContract, getContracts, clearContracts, getContractsOfProject})(WorkflowList);